import debug from 'debug';

const debugLogger = debug('data-api-honey-rest:client');
const isNotAvailableForGuestError = (response)=>response?.status === 401 && response?.data?.error?.message === 'Not available for guest users' || response?.data?.error?.message === 'jwt unauthorized';
const isTokenInvalidError = (response)=>response?.status === 401 && (response?.data?.error?.message === 'jwt malformed' || response?.data?.error?.message === 'invalid token' || response?.data?.error?.message.startsWith('Unexpected token') || response?.data?.error?.message === `Authorization header is not of type 'Bearer'.` || response?.data?.error?.message === `Authorization header not found.` || response?.data?.error?.message === `invalid signature`);
const isTokenExpiredError = (response)=>response?.status === 401 && response?.data?.error?.message === 'jwt expired';
const getCurrentTokenFromError = (error)=>(error?.config?.headers?.Authorization || '').split(' ')[1];
const authInterceptorError = (clientInstance)=>async (error)=>{
        const retry = error?.config?._retry || 0;
        if (retry < error?.config?._retry_max) {
            if (isNotAvailableForGuestError(error?.response) && typeof error?.config?.handleInsufficientAuth === 'function') {
                debugLogger('Handle insufficient Authorization');
                await error?.config?.handleInsufficientAuth(error?.config?.headers?.isSalesAgentRequest);
            } else if (isTokenInvalidError(error?.response) && typeof error?.config?.handleInsufficientAuth === 'function' && error?.config?.headers?.isSalesAgentRequest) {
                /**
			 * Sales Agent don't have a guest mode
			 * so we need to handle insufficient auth
			 * when sales agent token is invalid
			 */ await error?.config?.handleInsufficientAuth(error?.config?.headers?.isSalesAgentRequest);
            } else if (isTokenInvalidError(error?.response) && typeof error?.config?.handleAuthInit === 'function') {
                debugLogger('Regenerate JWT due to error: %s', error?.response?.data?.error?.message);
                try {
                    const currentToken = getCurrentTokenFromError(error);
                    const { token  } = await error.config.handleAuthInit(currentToken);
                    return clientInstance({
                        ...error.config,
                        headers: {
                            ...error.config.headers,
                            Authorization: `Bearer ${token}`
                        },
                        transformRequest: clientInstance.defaults.transformRequest,
                        _retry: retry + 1
                    });
                } catch (err) {
                    return Promise.reject(err);
                }
            } else if (isTokenExpiredError(error?.response) && typeof error?.config?.handleAuthRefresh === 'function') {
                debugLogger('Refresh JWT due to error: %s', error?.response?.data?.error?.message);
                try {
                    const currentToken = getCurrentTokenFromError(error);
                    const { token  } = await error.config.handleAuthRefresh(currentToken, error?.config?.headers?.isSalesAgentRequest);
                    return clientInstance({
                        ...error.config,
                        headers: {
                            ...error.config.headers,
                            Authorization: `Bearer ${token}`
                        },
                        transformRequest: clientInstance.defaults.transformRequest,
                        _retry: retry + 1
                    });
                } catch (err) {
                    return Promise.reject(err);
                }
            }
        }
        return Promise.reject(error);
    };

export { authInterceptorError };
